var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.4917 1.66669H6.50835C3.47502 1.66669 1.66669 3.47502 1.66669 6.50835V13.4834C1.66669 16.525 3.47502 18.3334 6.50835 18.3334H13.4834C16.5167 18.3334 18.325 16.525 18.325 13.4917V6.50835C18.3334 3.47502 16.525 1.66669 13.4917 1.66669Z",
    fill: "#CCC292"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6833 6.50665V13.49C13.6833 14.0233 13.25 14.4566 12.7167 14.4566C12.175 14.4566 11.7417 14.0233 11.7417 13.49V6.50665C11.7417 5.97331 12.175 5.53998 12.7167 5.53998C13.25 5.53998 13.6833 5.97331 13.6833 6.50665ZM8.25832 10.775V13.4916C8.25832 14.025 7.82498 14.4583 7.28332 14.4583C6.74998 14.4583 6.31665 14.025 6.31665 13.4916V10.775C6.31665 10.2416 6.74998 9.80831 7.28332 9.80831C7.82498 9.80831 8.25832 10.2416 8.25832 10.775Z",
    fill: "#CCC292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/chart-icon.e7604f71c36a6e6a52e56a4e66906048.svg";
export { ForwardRef as ReactComponent };